import { Cookies } from 'react-cookie';
export class AuthHandler {
    constructor({ cookies }) {
        this.authToken = null;
        this.cookies = new Cookies();
        this.setAuthToken = (newToken) => {
            if (!newToken)
                return;
            this.authToken = newToken;
            const expires = new Date();
            expires.setMonth(new Date().getMonth() + 1);
            this.cookies.set('authToken', newToken, {
                expires,
                path: '/',
                sameSite: true
            });
        };
        this.loadAuthToken = () => {
            const cookieAuthToken = this.cookies.get('authToken');
            if (cookieAuthToken) {
                this.authToken = cookieAuthToken;
            }
        };
        this.clearAuthToken = () => {
            this.authToken = null;
            if (this.cookies.get('authToken')) {
                this.cookies.remove('authToken', { path: '/' });
            }
        };
        this.getAuthHeaders = () => {
            return {
                authorization: this.authToken ? `Bearer ${this.authToken}` : ''
            };
        };
        this.cookies = cookies;
        this.loadAuthToken();
    }
}
//# sourceMappingURL=AuthHandler.js.map